/* projects/portal/src/app/pages/overview/overview.component.css */
.stat-grid {
  margin-bottom: 16px;
}
/*# sourceMappingURL=overview.component.css.map */
